import { Note, PutNoteInput, PutNoteResponse } from "../../types/api/admin/note";
import { request } from "../apiService";

export const getUserNotes = async (userId: string) => {
    return await request<Note>(`/v2/users/${userId}/notes`);
};

export const saveNotes = async (userId: string, input: PutNoteInput) => {
    return await request<PutNoteResponse, PutNoteInput>(
        `/v2/users/${userId}/notes`,
        {
            method: "PUT",
            input
        }
    );
};
